// Traduções da Programação do portal — coletadas por glob em core/i18n/messages.ts.
// Sem parêntese nem travessão no texto: a informação secundária vai em outra linha.
export default {
  pt: {
    'portal.programacao.palavraCarga': 'carga',
    'portal.programacao.palavraCargas': 'cargas',
    'portal.programacao.naoInformado': 'Não informado',
    'portal.programacao.title': 'Programação',
    'portal.programacao.eyebrow': 'Portal do cliente',
    'portal.programacao.subtitle': 'Escolha o dia, o contrato e os horários das cargas.',
    'portal.programacao.nova': 'Nova programação',
    'portal.programacao.hoje': 'Hoje',
    'portal.programacao.amanha': 'Amanhã',
    'portal.programacao.outraData': 'Outra data',
    'portal.programacao.diasAria': 'Dia da programação',
    'portal.programacao.badgeProgramacoes': '{{n}} programadas',
    'portal.programacao.vazioTitulo': 'Nada programado para {{dia}}',
    'portal.programacao.vazioTexto': 'Escolha o contrato, quantas cargas e os horários. O programador recebe na hora.',
    'portal.programacao.carregando': 'Carregando a programação do dia',
    'portal.programacao.erro': 'Não foi possível carregar a programação do dia.',
    'portal.programacao.tentarDeNovo': 'Tentar de novo',

    'portal.programacao.estado.enviada': 'Enviada',
    'portal.programacao.estado.reprogramada': 'Reprogramada',
    'portal.programacao.estado.em_atendimento': 'Em atendimento',
    'portal.programacao.fazenda': 'Fazenda',
    'portal.programacao.destino': 'Destino',
    'portal.programacao.umaCarga': '1 carga',
    'portal.programacao.nCargas': '{{n}} cargas',
    'portal.programacao.dasAs': 'das {{de}} às {{ate}}',
    'portal.programacao.as': 'às {{h}}',
    'portal.programacao.reprogramar': 'Reprogramar',
    'portal.programacao.diaPassado': 'O dia já passou',
    'portal.programacao.cargaTravada': 'Já começou, não muda mais',

    'portal.programacao.andamento.carregando': 'Carregando',
    'portal.programacao.andamento.transito': 'Em trânsito',
    'portal.programacao.andamento.descarregando': 'Descarregando',
    'portal.programacao.andamento.atendida': 'Atendida',
    'portal.programacao.andamento.naoAtendida': 'Não atendida',
    'portal.programacao.andamento.emAndamento': 'Em andamento',

    'portal.programacao.form.tituloNova': 'Nova programação',
    'portal.programacao.form.tituloReprogramar': 'Reprogramar',
    'portal.programacao.form.para': 'Para {{dia}}',
    'portal.programacao.form.fechar': 'Fechar',
    'portal.programacao.form.passoContrato': 'Contrato',
    'portal.programacao.form.passoQuantidade': 'Quantas cargas',
    'portal.programacao.form.passoHorarios': 'Horários',
    'portal.programacao.form.selecione': 'Selecione o contrato',
    'portal.programacao.form.buscar': 'Buscar pelo número, produtor ou fazenda',
    'portal.programacao.form.menos': 'Uma carga a menos',
    'portal.programacao.form.mais': 'Uma carga a mais',
    'portal.programacao.form.limite': 'Até {{n}} cargas por programação',
    'portal.programacao.form.minimoTravadas': '{{n}} já começaram e continuam na programação',
    'portal.programacao.form.minimoUmaTravada': '1 já começou e continua na programação',
    'portal.programacao.form.primeiro': 'Primeiro horário',
    'portal.programacao.form.intervalo': 'Intervalo',
    'portal.programacao.form.minutos': '{{n}} min',
    'portal.programacao.form.toqueParaAjustar': 'Toque em um horário para ajustar só aquela carga.',
    'portal.programacao.form.ajustarCarga': 'Carga {{n}}',
    'portal.programacao.form.voltarAoPadrao': 'Voltar ao padrão',
    'portal.programacao.form.ok': 'Pronto',
    'portal.programacao.form.ajustado': 'Ajustado à mão',
    'portal.programacao.form.jaComecaram': 'Já começaram',
    'portal.programacao.form.livres': 'Para reprogramar',
    'portal.programacao.form.duplicadaTitulo': 'Este contrato já tem programação para {{dia}}',
    'portal.programacao.form.duplicadaTexto': 'Para alterar as cargas, solicite a reprogramação.',
    'portal.programacao.form.reprogramarEsta': 'Reprogramar esta programação',
    'portal.programacao.form.enviar': 'Enviar programação',
    'portal.programacao.form.revisar': 'Revisar e enviar',
    'portal.programacao.form.enviando': 'Enviando',
    'portal.programacao.form.semMudanca': 'Nada mudou ainda',
    'portal.programacao.form.enviada': 'Programação enviada. O programador já foi avisado.',
    'portal.programacao.form.reprogramada': 'Reprogramação enviada. O programador já foi avisado.',
    'portal.programacao.form.horarioInvalido': 'Confira os horários das cargas.',

    'portal.programacao.confirmar.titulo': 'Confirmar a reprogramação',
    'portal.programacao.confirmar.antes': 'Antes',
    'portal.programacao.confirmar.agora': 'Agora',
    'portal.programacao.confirmar.legenda': 'Em destaque, os horários que mudam.',
    'portal.programacao.confirmar.voltar': 'Voltar',
    'portal.programacao.confirmar.enviar': 'Confirmar',
  },
  en: {
    'portal.programacao.palavraCarga': 'load',
    'portal.programacao.palavraCargas': 'loads',
    'portal.programacao.naoInformado': 'Not informed',
    'portal.programacao.title': 'Schedule',
    'portal.programacao.eyebrow': 'Customer portal',
    'portal.programacao.subtitle': 'Pick the day, the contract and the load times.',
    'portal.programacao.nova': 'New schedule',
    'portal.programacao.hoje': 'Today',
    'portal.programacao.amanha': 'Tomorrow',
    'portal.programacao.outraData': 'Other date',
    'portal.programacao.diasAria': 'Schedule day',
    'portal.programacao.badgeProgramacoes': '{{n}} scheduled',
    'portal.programacao.vazioTitulo': 'Nothing scheduled for {{dia}}',
    'portal.programacao.vazioTexto': 'Pick the contract, how many loads and the times. The scheduler is notified right away.',
    'portal.programacao.carregando': 'Loading the day schedule',
    'portal.programacao.erro': 'Could not load the day schedule.',
    'portal.programacao.tentarDeNovo': 'Try again',

    'portal.programacao.estado.enviada': 'Sent',
    'portal.programacao.estado.reprogramada': 'Rescheduled',
    'portal.programacao.estado.em_atendimento': 'In progress',
    'portal.programacao.fazenda': 'Farm',
    'portal.programacao.destino': 'Destination',
    'portal.programacao.umaCarga': '1 load',
    'portal.programacao.nCargas': '{{n}} loads',
    'portal.programacao.dasAs': 'from {{de}} to {{ate}}',
    'portal.programacao.as': 'at {{h}}',
    'portal.programacao.reprogramar': 'Reschedule',
    'portal.programacao.diaPassado': 'This day is over',
    'portal.programacao.cargaTravada': 'Already started, can no longer change',

    'portal.programacao.andamento.carregando': 'Loading',
    'portal.programacao.andamento.transito': 'In transit',
    'portal.programacao.andamento.descarregando': 'Unloading',
    'portal.programacao.andamento.atendida': 'Delivered',
    'portal.programacao.andamento.naoAtendida': 'Not served',
    'portal.programacao.andamento.emAndamento': 'In progress',

    'portal.programacao.form.tituloNova': 'New schedule',
    'portal.programacao.form.tituloReprogramar': 'Reschedule',
    'portal.programacao.form.para': 'For {{dia}}',
    'portal.programacao.form.fechar': 'Close',
    'portal.programacao.form.passoContrato': 'Contract',
    'portal.programacao.form.passoQuantidade': 'How many loads',
    'portal.programacao.form.passoHorarios': 'Times',
    'portal.programacao.form.selecione': 'Select the contract',
    'portal.programacao.form.buscar': 'Search by number, producer or farm',
    'portal.programacao.form.menos': 'One load less',
    'portal.programacao.form.mais': 'One load more',
    'portal.programacao.form.limite': 'Up to {{n}} loads per schedule',
    'portal.programacao.form.minimoTravadas': '{{n}} already started and stay in the schedule',
    'portal.programacao.form.minimoUmaTravada': '1 already started and stays in the schedule',
    'portal.programacao.form.primeiro': 'First time',
    'portal.programacao.form.intervalo': 'Interval',
    'portal.programacao.form.minutos': '{{n}} min',
    'portal.programacao.form.toqueParaAjustar': 'Tap a time to adjust only that load.',
    'portal.programacao.form.ajustarCarga': 'Load {{n}}',
    'portal.programacao.form.voltarAoPadrao': 'Back to default',
    'portal.programacao.form.ok': 'Done',
    'portal.programacao.form.ajustado': 'Adjusted by hand',
    'portal.programacao.form.jaComecaram': 'Already started',
    'portal.programacao.form.livres': 'To reschedule',
    'portal.programacao.form.duplicadaTitulo': 'This contract already has a schedule for {{dia}}',
    'portal.programacao.form.duplicadaTexto': 'To change the loads, request a reschedule.',
    'portal.programacao.form.reprogramarEsta': 'Reschedule this one',
    'portal.programacao.form.enviar': 'Send schedule',
    'portal.programacao.form.revisar': 'Review and send',
    'portal.programacao.form.enviando': 'Sending',
    'portal.programacao.form.semMudanca': 'Nothing changed yet',
    'portal.programacao.form.enviada': 'Schedule sent. The scheduler has been notified.',
    'portal.programacao.form.reprogramada': 'Reschedule sent. The scheduler has been notified.',
    'portal.programacao.form.horarioInvalido': 'Check the load times.',

    'portal.programacao.confirmar.titulo': 'Confirm the reschedule',
    'portal.programacao.confirmar.antes': 'Before',
    'portal.programacao.confirmar.agora': 'Now',
    'portal.programacao.confirmar.legenda': 'Highlighted, the times that change.',
    'portal.programacao.confirmar.voltar': 'Back',
    'portal.programacao.confirmar.enviar': 'Confirm',
  },
  es: {
    'portal.programacao.palavraCarga': 'carga',
    'portal.programacao.palavraCargas': 'cargas',
    'portal.programacao.naoInformado': 'No informado',
    'portal.programacao.title': 'Programación',
    'portal.programacao.eyebrow': 'Portal del cliente',
    'portal.programacao.subtitle': 'Elija el día, el contrato y los horarios de las cargas.',
    'portal.programacao.nova': 'Nueva programación',
    'portal.programacao.hoje': 'Hoy',
    'portal.programacao.amanha': 'Mañana',
    'portal.programacao.outraData': 'Otra fecha',
    'portal.programacao.diasAria': 'Día de la programación',
    'portal.programacao.badgeProgramacoes': '{{n}} programadas',
    'portal.programacao.vazioTitulo': 'Nada programado para {{dia}}',
    'portal.programacao.vazioTexto': 'Elija el contrato, cuántas cargas y los horarios. El programador recibe al instante.',
    'portal.programacao.carregando': 'Cargando la programación del día',
    'portal.programacao.erro': 'No fue posible cargar la programación del día.',
    'portal.programacao.tentarDeNovo': 'Intentar de nuevo',

    'portal.programacao.estado.enviada': 'Enviada',
    'portal.programacao.estado.reprogramada': 'Reprogramada',
    'portal.programacao.estado.em_atendimento': 'En atención',
    'portal.programacao.fazenda': 'Hacienda',
    'portal.programacao.destino': 'Destino',
    'portal.programacao.umaCarga': '1 carga',
    'portal.programacao.nCargas': '{{n}} cargas',
    'portal.programacao.dasAs': 'de {{de}} a {{ate}}',
    'portal.programacao.as': 'a las {{h}}',
    'portal.programacao.reprogramar': 'Reprogramar',
    'portal.programacao.diaPassado': 'El día ya pasó',
    'portal.programacao.cargaTravada': 'Ya empezó, no cambia más',

    'portal.programacao.andamento.carregando': 'Cargando',
    'portal.programacao.andamento.transito': 'En tránsito',
    'portal.programacao.andamento.descarregando': 'Descargando',
    'portal.programacao.andamento.atendida': 'Atendida',
    'portal.programacao.andamento.naoAtendida': 'No atendida',
    'portal.programacao.andamento.emAndamento': 'En curso',

    'portal.programacao.form.tituloNova': 'Nueva programación',
    'portal.programacao.form.tituloReprogramar': 'Reprogramar',
    'portal.programacao.form.para': 'Para {{dia}}',
    'portal.programacao.form.fechar': 'Cerrar',
    'portal.programacao.form.passoContrato': 'Contrato',
    'portal.programacao.form.passoQuantidade': 'Cuántas cargas',
    'portal.programacao.form.passoHorarios': 'Horarios',
    'portal.programacao.form.selecione': 'Seleccione el contrato',
    'portal.programacao.form.buscar': 'Buscar por número, productor o hacienda',
    'portal.programacao.form.menos': 'Una carga menos',
    'portal.programacao.form.mais': 'Una carga más',
    'portal.programacao.form.limite': 'Hasta {{n}} cargas por programación',
    'portal.programacao.form.minimoTravadas': '{{n}} ya empezaron y siguen en la programación',
    'portal.programacao.form.minimoUmaTravada': '1 ya empezó y sigue en la programación',
    'portal.programacao.form.primeiro': 'Primer horario',
    'portal.programacao.form.intervalo': 'Intervalo',
    'portal.programacao.form.minutos': '{{n}} min',
    'portal.programacao.form.toqueParaAjustar': 'Toque un horario para ajustar solo esa carga.',
    'portal.programacao.form.ajustarCarga': 'Carga {{n}}',
    'portal.programacao.form.voltarAoPadrao': 'Volver al estándar',
    'portal.programacao.form.ok': 'Listo',
    'portal.programacao.form.ajustado': 'Ajustado a mano',
    'portal.programacao.form.jaComecaram': 'Ya empezaron',
    'portal.programacao.form.livres': 'Para reprogramar',
    'portal.programacao.form.duplicadaTitulo': 'Este contrato ya tiene programación para {{dia}}',
    'portal.programacao.form.duplicadaTexto': 'Para cambiar las cargas, solicite la reprogramación.',
    'portal.programacao.form.reprogramarEsta': 'Reprogramar esta programación',
    'portal.programacao.form.enviar': 'Enviar programación',
    'portal.programacao.form.revisar': 'Revisar y enviar',
    'portal.programacao.form.enviando': 'Enviando',
    'portal.programacao.form.semMudanca': 'Nada cambió todavía',
    'portal.programacao.form.enviada': 'Programación enviada. El programador ya fue avisado.',
    'portal.programacao.form.reprogramada': 'Reprogramación enviada. El programador ya fue avisado.',
    'portal.programacao.form.horarioInvalido': 'Revise los horarios de las cargas.',

    'portal.programacao.confirmar.titulo': 'Confirmar la reprogramación',
    'portal.programacao.confirmar.antes': 'Antes',
    'portal.programacao.confirmar.agora': 'Ahora',
    'portal.programacao.confirmar.legenda': 'Destacados, los horarios que cambian.',
    'portal.programacao.confirmar.voltar': 'Volver',
    'portal.programacao.confirmar.enviar': 'Confirmar',
  },
}
